import axios from "axios";
import { StarOutline } from "iconoir-react";
import { BASE_URL, DRIVER_COMMISSION, RIDE_PAYMENT, TRANSFER, TRANSFER_DEDUCTION, TRANSFER_TOPUP, WALLET_REFUND, WALLET_TOPUP, WITHDRAWAL } from "./redux_store/asyncConfig";

export const displayFile = (fileData, output) => {
  if(fileData){
    output.innerHTML = '';
    if(typeof fileData === 'string'){
      output.style.backgroundImage=`url(${fileData})`;
      output.style.backgroundPosition = 'center';
      output.style.backgroundSize = 'cover';
    }else{
      const reader = new FileReader();
      reader.onload = function(){
        if(output){
          output.style.backgroundPosition = 'center';
          output.style.backgroundSize = 'cover';
          output.style.backgroundImage=`url(${reader.result})`;
        }
      };
      reader.readAsDataURL(fileData);
    }
  }else{
    output.innerHTML = '<p class="text-sm text-slate-600">No image available</p>'
    output.classList.add('bg-opacity-50', 'flex', 'justify-center', 'items-center', 'bg-gray-100')
  }
}

export const generatePromoCode = () => {
  let result = '';
  let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let charactersLength = characters.length;
  for ( let i = 0; i < 7; i++ ) {
    result += characters.charAt(
      Math.floor(Math.random() * charactersLength)
    );
  }
  return result;
}

export const getAmount = (transaction) => {
  let amount = 0;
  if(transaction.status === WALLET_TOPUP)
    amount = transaction.credit_amount_added;      
  else if (transaction.status === WALLET_REFUND)
    amount = 0
  else if (transaction.status === TRANSFER_DEDUCTION)
    amount = transaction.credit_amount_deducted;
  else if (transaction.status === TRANSFER_TOPUP)
    amount = transaction.credit_amount_added;
  else if (transaction.status === WITHDRAWAL)
    amount = transaction.credit_amount_deducted;
  else if (transaction.status === DRIVER_COMMISSION)
    amount = transaction.credit_amount_deducted
  else if (transaction.status === TRANSFER)
    amount = 0
  else if (transaction.status === RIDE_PAYMENT)
    amount = transaction.credit_amount_deducted
  return convertFromPesewasToCedis(amount);
}

export const convertFromPesewasToCedis = (amount) => {
  return amount ? Number(Math.abs(amount)) / 100: 0;
}

export const convertFromCedisToPesewas = (amount) => {
  return Number(amount) * 100;
}

export const getUserStars = (rate) => {
  const stars = [];
  for (let i = 0; i < rate; i++) {
    stars.push(<StarOutline fill="rgb(250 204 21)" className=" textye"/>)
  }
  return stars;
}

export const uploadFile = async (file, bucket, user_id = 1) => {
  const formData = new FormData();
  formData.append('files', file);
  formData.append('bucket', bucket);
  formData.append('user_id', user_id);

  try {
    const {data} = await axios.post(`${BASE_URL}/uploads`, formData);
    return data;
  } catch (error) {
    return error;
  }
}

export function getOS() {
  var userAgent = window.navigator.userAgent,
      platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (/Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
}

// alert(getOS());